export class AddFolderVM {
    userID: string;
    databaseID: number;
    folderName: string;
    folderType: number = 0;
}
